class ProviderTab extends HTMLElement {
  connectedCallback() {
    // Cache only what's specific to this element and never changes
    this.wrapper = this.closest('.installments-popup_content');
    this.tabId = this.getAttribute('data-id');
    this.tab = this.closest('.installments-popup_provider-logo');
    this.targetInfo = this.wrapper.querySelector(`.installments-popup_provider-info-wrapper[data-id="${this.tabId}"]`);

    this.addEventListener('click', this.handleTabClick.bind(this));
  }

  handleTabClick() {
    // Do nothing if this tab is already active
    if (this.tab.classList.contains('active')) return;

    // Always query the currently active elements fresh so state stays accurate
    const activeTab = this.wrapper.querySelector('.installments-popup_provider-logo.active');
    const activeInfo = this.wrapper.querySelector('.installments-popup_provider-info-wrapper.active');

    activeTab?.classList.remove('active');
    activeInfo?.classList.remove('active');

    // Activate the clicked tab and its matching info panel
    this.tab.classList.add('active');
    this.targetInfo.classList.add('active');
  }
}

if (!customElements.get('provider-tab')) customElements.define('provider-tab', ProviderTab);

class ProviderTypeSwitcher extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', this.handleTypeClick.bind(this));
    });
  }

  handleTypeClick(event) {
    const clickedButton = event.currentTarget;
    const type = clickedButton.getAttribute('data-tab-id');
    const buttons = this.querySelectorAll('button');
    const wrapper = this.closest('.installments-popup_content');
    const logos = wrapper.querySelectorAll('.installments-popup_provider-logo');

    // Remove active class from all buttons
    buttons.forEach((button) => {
      button.classList.remove('active');
    });
    
    // Remove active class from all logos
    logos.forEach((logo) => {
      logo.classList.remove('visible');
    });

    // Add active class to the clicked button
    clickedButton.classList.add('active');

    // Filter logos based on the selected type
    logos.forEach((logo) => {
      if (logo.getAttribute('data-provider-type') === type) {
        logo.classList.add('visible');
      }
    });

    // Select the first visible logo and click it
    const firstVisibleLogoTab = wrapper.querySelector('.installments-popup_provider-logo.visible provider-tab');
    firstVisibleLogoTab.click();
  }
}

if (!customElements.get('provider-type-switcher')) customElements.define('provider-type-switcher', ProviderTypeSwitcher);